import React from 'react'

export const handleKeyDown = (key: string, handler: Function) => (event: React.KeyboardEvent) => {
  if (event.key === key) {
    event.preventDefault()
    handler()
  }
}
